import React, { useEffect, useState } from "react";
import AuthRepository from "assets/scripts/domain/auth/AuthRepository";
import StatusMessage from "assets/scripts/components/presentational/StatusMessage";
import { push } from "react-router-redux";
import useRedux from "assets/scripts/hooks/useRedux";
import { confirmBackToFront } from "assets/scripts/domain/validation/dataConversion";
import useQuickPayContext from "./useQuickPayContext";
import Disclosures from "assets/scripts/components/containers/public/legal/Disclosures/Disclosures";
import ContactPublic from "assets/scripts/components/containers/public/ContactPublic";
import Payment from "./Payment";
import Registration from "./Registration";
import { FormattedMessage } from "react-intl";
export default function QuickPay(props) {
    const [rState, dispatch] = useRedux(state => ({
        loggedIn: state.auth.loggedIn,
        profile: state.profile.profile,
    }));
    const subPath = props.params.subpath.toLowerCase();
    const quickPayContext = useQuickPayContext();
    const [ineligible, setIneligible] = useState(false);
    const [account, setAccount] = useState(null);
    const [email, setEmail] = useState("");
    const [token, setToken] = useState("");
    const [pin, setPin] = useState(0);
    const [confirmationRequirements, setConfirmationRequirements] = useState(null);
    const [relationship, setRelationship] = useState("Attorney");
    const [quickPayType, setQuickPayType] = useState("Email");
    useEffect(() => () => quickPayContext.setToken(null), []);
    useEffect(() => {
        quickPayContext.setToken(null);
        setAccount(null);
        setIneligible(false);
        setEmail("");
        setToken("");
        setPin(0);
        setConfirmationRequirements(null);
        setRelationship("Attorney");
        setQuickPayType("Email");
        const onLoad = async () => {
            try {
                const result = await AuthRepository.quickPay(props.params.token);
                if (result.success && result.data.success) {
                    const { data } = result;
                    if (data.ineligible) {
                        setIneligible(true);
                        return;
                    }
                    setQuickPayType(data.quickPayType);
                    setPin(data.pin);
                    setEmail(data.email);
                    setToken(data.token);
                    setRelationship(data.decedentRelationship === "All" ? undefined : data.decedentRelationship);
                    setConfirmationRequirements(confirmBackToFront(data.confirmationRequirements));
                    setAccount(data.account);
                    quickPayContext.setToken(data.token);
                    quickPayContext.setQuickPayOnly(data.quickPayOnly);
                    return;
                }
            }
            catch {
                // ignore api error
            }
            if (rState.loggedIn && rState.profile != null) {
                dispatch(push("/secured"));
                return;
            }
            dispatch(push("/public"));
        };
        onLoad();
    }, [props.params.token]);
    if (ineligible) {
        return (<div className={`wrapper ${process.env.FEATURE_PAYMENT_WIZARD ? "wrapper_narrowPlus" : "wrapper_medium"}`}>
				<FormattedMessage id="account.closed.message" defaultMessage="We apologize for the inconvenience but we are unable to add this account. Please contact our office at 1-877-326-8786."/>
			</div>);
    }
    if (!account) {
        return (<div className={`wrapper ${process.env.FEATURE_PAYMENT_WIZARD ? "wrapper_narrowPlus" : "wrapper_medium"}`}>
				<StatusMessage isLoad isActive/>
			</div>);
    }
    switch (subPath) {
        case "register":
            return (<Registration account={account} confirmationRequirements={confirmationRequirements} email={email} pin={pin} setAccount={setAccount} token={token} relationship={relationship} quickPayType={quickPayType}/>);
        case "disclosures":
            return (<Disclosures />);
        case "contact":
            return (<ContactPublic account={account}/>);
        default:
            return (<Payment key={account.id} account={account} email={email} pin={pin} setAccount={setAccount} token={token} confirmationRequirements={confirmationRequirements} relationship={relationship} quickPayType={quickPayType}/>);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/QuickPay/QuickPay.tsx